module.exports = __webpack_public_path__ + "img/countdown.a69bf0f7.png";